import { Component, OnInit } from '@angular/core';
import { ROUTES } from './sidebar-routes.config';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { SidebarService } from "./sidebar.service";
import { AuthenticationService } from '../../app-okc/shared-gz/services/authentication.service';

import * as $ from 'jquery';


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
})

export class SidebarComponent implements OnInit {

  public menuItems: any[];


  constructor(
    public sidebarservice: SidebarService,
    private router: Router,
    private _auth: AuthenticationService
  ) {

    router.events.subscribe((event: Event) => {

      if (event instanceof NavigationStart) {
        // Show loading indicator
      }

      if (event instanceof NavigationEnd && $(window).width() < 1025 && (document.readyState == 'complete' || false)) {

        this.toggleSidebar();
        // Hide loading indicator

      }

      if (event instanceof NavigationError) {
        // Hide loading indicator

        // Present error to user
        console.log(event.error);
      }
    });

  }


  toggleSidebar() {
    this.sidebarservice.setSidebarState(!this.sidebarservice.getSidebarState());

    if ($(".wrapper").hasClass("nav-collapsed")) {
      // unpin sidebar when hovered
      $(".wrapper").removeClass("nav-collapsed");
      $(".sidebar-wrapper").unbind("hover");
    } else {
      $(".wrapper").addClass("nav-collapsed");
      $(".sidebar-wrapper").hover(
        function () {
          $(".wrapper").addClass("sidebar-hovered");
        },
        function () {
          $(".wrapper").removeClass("sidebar-hovered");
        }
      )

    }

  }

  getSideBarState() {
    return this.sidebarservice.getSidebarState();
  }

  hideSidebar() {
    this.sidebarservice.setSidebarState(true);
  }


  ngOnInit() {
    const vm = this;
    const user = vm._auth.userObj;
    if (user) {
      if (user.isAdmin) {
        vm.generateNav(['All', 'Admin']);
      } else if (user.isOperator) {
        vm.generateNav(['Operator']);
      }
    }
    $.getScript('./assets/js/app-sidebar.js');
  }

  generateNav(match) {
    this.menuItems = ROUTES.filter(mi => {
      let flag = false;
      match.forEach(m => {
        mi.users.forEach(u => {
          if (u === m) {
            flag = true;
          }
        });
      });
      return flag;
    });
  }

}
